import React from 'react';
import java from "../images/java.svg";
import kotlin from "../images/kotlin.png";
import jscript from "../images/jscript.png";
import typejs from "../images/typejs.png";
import react from "../images/react.png";
import native from "../images/native.png";
import selenium from "../images/selenium.png";
import qa from "../images/qa.png";
import cypress from "../images/cypress.png";
import postman from "../images/postman.png";
import mysql from "../images/mysql_image.png";
import html from "../images/html.png";
import css from "../images/CSS3.jpeg";
import php from "../images/php_.png";

import { Timeline,TimelineConnector,TimelineContent,TimelineItem, TimelineOppositeContent, TimelineSeparator } from '@material-ui/lab';
import { makeStyles, Paper, Typography } from '@material-ui/core';
import StarRating from './StarRating';

const Technologies = () => {

    const classes = useStyles();

const skills=[
   {
       year:2020,
       src:java,
       title:"Java",
       starts:3,
       description:"Bootcamp Desafio Digital, Developer Android",
       
   },
   {
        year:2020,
        src:kotlin,
        title:"Kotlin",
        starts:4,
        description:"Bootcamp Desafio Digital, Developer Android"
    },
    {
        year:2020,
        src:jscript,
        title:"JavaScript",
        starts:3,
        description:"Autodidact"
    },
    {
        year:2021,
        src:typejs,
        title:"TypeScript",
        starts:3,
        description:"Autodidact"
    },
    {
        year:2021,
        src:react,
        title:"ReactJs",
        starts:3,
        description:"Autodidact"
    },
    {
        year:2021,
        src:native,
        title:"React Native",
        starts:3,
        description:"Autodidact"
    },
    {
        year:2021,
        src:qa,
        title:"Tester QA",
        starts:3,
        description:"Abstracta Academy"
    },
    {
        year:2021,
        src:selenium,
        title:"Selenium",
        starts:2,
        description:"Autodidact"
    },
    {
        year:2021,
        src:cypress,
        title:"Cypress.io",
        starts:2,
        description:"Autodidact Platzi"
    },
    {
        year:2021,
        src:postman,
        title:"Postman",
        starts:2,
        description:"Autodidact Platzi and Udemy"
    },
    {
        year:2021,
        src:mysql,
        title:"My SQL",
        starts:2,
        description:"Professional practice"
    },
    {
        year:2021,
        src:html,
        title:"HTML",
        starts:2,
        description:"Professional practice"
    },
    {
        year:2021,
        src:css,
        title:"CSS",
        starts:2,
        description:"Professional practice"
    },
    {
        year:2021,
        src:php,
        title:"PHP",
        starts:2,
        description:"Professional practice"
    },
    
    
]

    return (
        <Timeline align="rigth">
            {
                skills.map(({year,src,title,starts,description},index) =>  (
                    <TimelineItem>
                        <TimelineOppositeContent>
                            <Typography >
                                 {year}
                            </Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <img src={src} alt={title} className={classes.customlogo} />
                          <TimelineConnector/>
                        </TimelineSeparator>
                        <TimelineContent>
                            <Paper elevation={3} className={classes.paper} >
                                <Typography
                                style={{fontFamily: "roboto"}}
                                variant="h6" component="h1">
                                        {title}
                                </Typography>
                                <StarRating className={classes.starts} starts={starts}/>
                                <Typography className={classes.description}
                                >
                                        {description}
                                </Typography>
                            </Paper>
                        </TimelineContent>

                    </TimelineItem>
                    
                ))
            }
        </Timeline>

        
    )
}
const useStyles = makeStyles((theme) => ({ 
    customlogo: {
       width:"60px",
       
    },
    paper:{
        color:"white",
       padding:"6px 16px",
       maxWidth:"200px",
       background:"#e0dede",
       transition:".5s",
       "&:hover":{
          background:"white",
          color:"#1eba8b",
          transform: `translateY(-7px)`

       }
       
    },
    
    
    

    description:{
        fontSize:"16px"
    }
  }))

export default Technologies;
